import { gql } from "@apollo/client";

export const AssetTabInfo = gql`
    query AssetTabInfo ($id: ID!){
        assetLocation (id: $id) {
            id
            installedBaseNode {
                id
                title
            }
            asset {
                id
                product {
                    id
                    name
                }
            }
        }
    }
`;
